import { styled } from '@mui/material/styles'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useUserListActionsModal } from '../../contexts/UserListActionsModalContext'
import CreateUpdateUserTabs from './CreateUpdateUserTabs'
import { useState } from 'react'

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: 0,
    paddingLeft: 24,
    paddingRight: 24,
  },
  '& .MuiDialogActions-root': {
    paddingTop: 0,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 32,
  },
}))

const initalUserData = {
  name: '',
  company_designated_id: '',
  email: '',
  mobile: '',
  legal_id: '',
  gender: '',
  birthday: '',
  locale: '',
  timezone: '',
  hired_at: '',
  began_at: '',
  removed_at: '',
  keep_history: true,
  show_in_reports: true,
  role_name: '',
  role_level: '',
  role_risk_level: '',
  team: '',
  area: '',
  shift: '',
  password: '',
  supervisor: [],
  usual_sleep: '',
  caffeine: '',
  caffeine_start: '',
}

const UserCreateUpdateActionsModal = ({ onSend, enableAnnotations }) => {
  const [userData, setUserData] = useState(initalUserData)
  const { open, closeActionsModal, handleUserSendClick } =
    useUserListActionsModal()

  const handleClick = () => {
    handleUserSendClick({ userData })
    onSend && onSend()
  }

  const onChangeTab = () => {
    setUserData(initalUserData)
  }

  return (
    <BootstrapDialog
      onClose={closeActionsModal}
      aria-labelledby='adm-actions-title'
      open={open}
    >
      <DialogTitle id='adm-actions-title'>Criar / Atualizar usuário</DialogTitle>
      <IconButton
        aria-label='close'
        onClick={closeActionsModal}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: '#000',
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <CreateUpdateUserTabs enableAnnotations={enableAnnotations} userData={userData} setUserData={setUserData} onChangeTab={onChangeTab} />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClick}
          variant='contained'
        >
          Enviar
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}

export default UserCreateUpdateActionsModal
